import { render, staticRenderFns } from "./relation_log.vue?vue&type=template&id=b2818870&scoped=true"
import script from "./relation_log.vue?vue&type=script&lang=ts"
export * from "./relation_log.vue?vue&type=script&lang=ts"
import style0 from "./relation_log.vue?vue&type=style&index=0&id=b2818870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2818870",
  null
  
)

export default component.exports